<template>
  <div>
    <div v-show="isLoading">
      <spin-loader />
    </div>
    <div>
      <history-list
        :history-list="historyList"
        :labels="labelList"
      />
    </div>
  </div>
</template>
<script>
import {
  mdiClipboardEditOutline,
  mdiClipboardRemoveOutline,
  mdiClipboardTextMultipleOutline,
  mdiPackageVariantPlus,
  mdiPackageVariantRemove,
  mdiPaperclipPlus,
  mdiPaperclipRemove,
} from '@mdi/js'

import {
  useToast,
} from 'vue-toastification/composition'

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import syslic from '@/syslic'
import SyncLoad from '@/components/utils/syncLoad'
import SpinLoader from '@/components/spinloader/SpinLoader.vue'
import HistoryList from '@/components/history/HistoryList.vue'

export default {
  components: {
    SpinLoader,
    HistoryList,
  },
  props: {
    commitmentId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    const isLoading = true
    const syncLoad = new SyncLoad()
    syncLoad.addTrigger('history')

    syncLoad.onReady(() => {
      this.isLoading = false
    })

    const historyList = []

    const labelList = [
      {
        type: '+',
        model: 'OrderCommitment',
        label: 'Cadastro de Empenho',
        icon: mdiClipboardTextMultipleOutline,
      },
      {
        type: '~',
        model: 'OrderCommitment',
        label: 'Edição do Empenho',
        icon: mdiClipboardEditOutline,
      },
      {
        type: '-',
        model: 'OrderCommitment',
        label: 'Exclusão de Empenho',
        icon: mdiClipboardRemoveOutline,
      },
      {
        type: '+',
        model: 'OrderCommitmentItem',
        label: 'Inclusão do Item',
        icon: mdiPackageVariantPlus,
      },
      {
        type: '-',
        model: 'OrderCommitmentItem',
        label: 'Exclusão do Item',
        icon: mdiPackageVariantRemove,
      },
      {
        type: '+',
        model: 'OrderCommitmentFile',
        label: 'Inclusão de Anexo',
        icon: mdiPaperclipPlus,
      },
      {
        type: '-',
        model: 'OrderCommitmentFile',
        label: 'Exclusão de Anexo',
        icon: mdiPaperclipRemove,
      },
    ]

    return {
      isLoading,
      syncLoad,
      historyList,
      labelList,
    }
  },
  computed: {

  },
  created() {
    this.fetchHistorics()
  },
  methods: {
    fetchHistorics() {
      syslic
        .order
        .commitment
        .history
        .fetchHistory(this.commitmentId)
        .then(response => {
          this.historyList = response.data.events
          this.syncLoad.ready('history')
        })
        .catch(() => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: 'Não foi possível carregar o histórico deste empenho.',
              text: 'Não foi possível carregar o histórico, por favor entre em contato com o administrador do sistema.',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              timeout: false,
            },
          })
          this.syncLoad.ready('history')
        })
    },
    isEmpty(obj) {
      return Object.keys(obj).length === 0
    },
  },
  setup() {
    const toast = useToast()

    return {
      toast,
      mdiClipboardEditOutline,
      mdiClipboardRemoveOutline,
      mdiClipboardTextMultipleOutline,
      mdiPackageVariantPlus,
      mdiPackageVariantRemove,
      mdiPaperclipPlus,
      mdiPaperclipRemove,
    }
  },
}
</script>

<style lang="sass">

</style>
